<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h2 mat-dialog-title>{{ titleKey | translate }}</h2>

  <mat-dialog-content>
    @if (apiError$ | async; as apiError) {
      <app-error-message>{{ apiError }}</app-error-message>
    }

    <app-input-wrapper [label]="'cisterns.form.name' | translate" [control]="form.controls['name']">
      <input type="text" formControlName="name" [placeholder]="'cisterns.form.name' | translate">
    </app-input-wrapper>

    <div class="grid grid-cols-2 gap-2">
      <app-input-wrapper
        [label]="'cisterns.form.distanceSensor' | translate"
        [control]="form.controls['distanceSensorId']"
        isSelect
      >
        <select formControlName="distanceSensorId">
          <option [ngValue]="null">{{ 'default.placeholder.select' | translate }}</option>
          @for (sensor of distanceSensors$ | async; track sensor.id) {
            <option [value]="sensor.id">{{ sensor.name }}</option>
          }
        </select>
      </app-input-wrapper>

      <app-input-wrapper [label]="'cisterns.form.literCapacity' | translate" unit="l" [control]="form.controls['literCapacity']">
        <input type="number" min="0" step="1" formControlName="literCapacity">
      </app-input-wrapper>

      <app-input-wrapper [label]="'cisterns.form.floorDistance' | translate" unit="cm" [control]="form.controls['floorDistance']">
        <input type="number" min="0" step="1" formControlName="floorDistance">
      </app-input-wrapper>

      <app-input-wrapper [label]="'cisterns.form.maxWaterLevelDistance' | translate" unit="cm" [control]="form.controls['maxWaterLevelDistance']">
        <input type="number" min="0" step="1" formControlName="maxWaterLevelDistance">
      </app-input-wrapper>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="button" class="button" mat-dialog-close>{{ 'default.cancel' | translate }}</button>
    <button class="button primary-button" [disabled]="form.invalid">{{ 'default.save' | translate }}</button>
  </mat-dialog-actions>
</form>
